import { TypeTipoDeViagem } from "../../../Models/Domain/Viagem/TipoDeViagem";
import { Axios } from "../../Axios";

export class TipoDeViagemService {

    public listarTiposDeViagem(filtro?: TypeTipoDeViagem){
        return Axios.post<TypeTipoDeViagem[]>(`quiron/viagem/tipos-de-viagem/listar`, filtro);
    }

    public inserirTipoDeViagem(payload: TypeTipoDeViagem) {
        return Axios.post<TypeTipoDeViagem>(`quiron/viagem/tipos-de-viagem`, payload);
    }

    public atualizarTipoDeViagem(payload: TypeTipoDeViagem) {
        return Axios.put<void>(`quiron/viagem/tipos-de-viagem`, payload);
    }

    public ativarTipoDeViagem(codigo: number) {
        return Axios.patch(`quiron/viagem/tipos-de-viagem/${codigo}/ativar`);
    }

    public desativarTipoDeViagem(codigo: number) {
        return Axios.patch(`quiron/viagem/tipos-de-viagem/${codigo}/desativar`);
    }

}